export enum AgeRatingDisplayType {
  ICON = 'icon',
  SYMBOL = 'value',
  DESCRIPTION = 'description',
}
